import Utils from 'core-helpers/utils.js';
import TranslationsService from 'common/translations.service.js';

const trialBanner = Utils.getById('claim-trial-banner');

// UI Classnames
const UI_DISABLED_CLASSNAME = 'claim-trial--disabled';

/**
 * Displays the number of days of free trial
 * @param {Number} durationDays
 */
const updateTrialDuration = (durationDays) => {
    const freeTrialDuration = Utils.getElementByClass('js-trial-duration', trialBanner);

    if (durationDays > 0) {
        freeTrialDuration.innerHTML = TranslationsService.getAndReplaceTranslationMulti('CLAIM_YOUR_X_DAYS_OF_PREMIUM', [durationDays]);
    }
};

/**
 * Remove hidden class from trial banner
 */
const showTrialBanner = () => {
    Utils.removeClass(trialBanner, 'hidden');
};

/**
 * Add disabled class to trial banner
 */
const disableBanner = () => {
    Utils.addClass(trialBanner, UI_DISABLED_CLASSNAME);
};

const FreeTrialUIService = {
    updateTrialDuration,
    showTrialBanner,
    disableBanner
};

export default FreeTrialUIService;
